import React from 'react';
import cx from 'classnames';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as Close } from '../../assets/img/icons/common/Close.svg';
import './Modal.scss';

export const DeleteSmth = ({ operation = 'Delete', title, span, id, the = false, opened, onConfirm, loading = false }) => {
  return (
    <div
      className="modal fade show"
      id="ModalPassword"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ModalPasswordLabel"
      aria-hidden="true"
    >
      <div role="document" className="modal-dialog modal-dialog-centered modal__delete modal__delete-sm">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">{operation} {title}</h4>
            <div className="modal-close__button" onClick={() => opened(false)}>
              <Close />
            </div>
          </div>
          <div className="modal-body">
            Do you want to {operation.toLowerCase()} {the ? 'the ' : ''}
            {title.toLowerCase()}
            {span && (
              <>
                {' '}
                <span className="delete__value">{span}</span>
              </>
            )}
            ?
          </div>
          <div className="modal-footer">
            <div className="modal-button__container">
              <button type="button" className="modal-button modal-button__cancel" onClick={() => opened('')}>
                Cancel
              </button>
              <button
                className={cx('modal-button modal-button__confirm modal-button__confirm-delete', {
                  disabled: loading,
                })}
                type="submit"
                disabled={loading}
                onClick={() => onConfirm(id)}
              >
                {operation}
                
                {loading ? (
                  <div className="modal-button__confirm-delete-loading">
                    <FontAwesomeIcon icon={faSpinner} size="lg" spin />
                  </div>
                ) : null}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
